export default __webpack_public_path__ + "static/media/MarketRealCase1.02d47423.svg";